import { formatNumber } from "@angular/common";

export default class Utils {

  public static formatToCurrency(number) {
    number = '$' + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return number;
  }

  public static formatToNumber(number) {
    // console.log(number);
    return Number(number.toString().split(',').join('').replace('$', ''));
  }
  public static calculateMostProfitableSpouse(client, spouses) {
    var profitableSpouse;

    var canClaimWidow = true;
    var canClaimDivorced = true;

    for (var spouse in spouses) {
      spouses[spouse].pia = Number(spouses[spouse].pia) ? spouses[spouse].pia : spouses[spouse].pia ? Number(spouses[spouse].pia.replace(/,/g, "").replace("$", "")) : 0;

      if (spouses[spouse].maritalStatus == 'Married' || spouses[spouse].maritalStatus == 'Divorced' && (typeof spouses[spouse].alive === 'string' ? spouses[spouse].alive != 'false' : spouses[spouse].alive)) {
        spouses[spouse].adjustedPia = spouses[spouse].pia / 2;
      } else {
        spouses[spouse].adjustedPia = spouses[spouse].pia;
      }

      if (spouses[spouse].maritalStatus == 'Married' && this.calculateMarriageAge(client.client, spouses[spouse]) < 60) {
        canClaimWidow = false;
      }

      if (spouses[spouse].maritalStatus == 'Married') {
        canClaimDivorced = false;
      }
    }

    for (var spouse in spouses) {
      if (!canClaimWidow && spouses[spouse].maritalStatus == 'Widowed') {
        // do nothing
      } else if ((spouses[spouse].maritalStatus == 'Divorced' && (spouses[spouse].tenyears == 'false' || !spouses[spouse].tenyears)) || (!canClaimDivorced && spouses[spouse].maritalStatus == 'Divorced')) {
        // do nothing
      } else if (!profitableSpouse) {
        profitableSpouse = spouses[spouse];
      } else {
        if (profitableSpouse.adjustedPia < spouses[spouse].adjustedPia) {
          profitableSpouse = spouses[spouse];
        }
      }
    }

    return [profitableSpouse];
  }

  /* public static calculateMostProfitableSpouse(client, spouses) {
    var profitableSpouse;

    var canClaimWidow = true;
    var canClaimDivorced = true;

    for (var spouse in spouses) {
      spouses[spouse].pia = spouses[spouse].pia ? (typeof spouses[spouse].pia === 'number' ? spouses[spouse].pia : Number(spouses[spouse].pia.replace(/,/g, "").replace("$", ""))) : 0;
      
      if (spouses[spouse].maritalStatus == 'Married' || (spouses[spouse].maritalStatus == 'Divorced' && (typeof spouses[spouse].alive === 'string' ? spouses[spouse].alive != 'false' : spouses[spouse].alive))) {
        spouses[spouse].adjustedPia = spouses[spouse].pia / 2;
      } else {
        spouses[spouse].adjustedPia = spouses[spouse].pia;
      }

      if (spouses[spouse].maritalStatus == 'Married' && this.calculateMarriageAge(client.client, spouses[spouse]) < 60) {
        canClaimWidow = false;
      }

      if (spouses[spouse].maritalStatus == 'Married') {
        canClaimDivorced = false;
      }
    }

    for (var spouse in spouses) {
      if (!canClaimWidow && spouses[spouse].maritalStatus == 'Widowed') {
        // do nothing
      } else if (!canClaimWidow && (spouses[spouse].maritalStatus == 'Divorced' && (spouses[spouse].tenyears == 'false' || !spouses[spouse].tenyears)) || (!canClaimDivorced && spouses[spouse].maritalStatus == 'Divorced')) {
        // do nothing
      } else if (!profitableSpouse) {
        profitableSpouse = spouses[spouse];
      } else {
        if (profitableSpouse.adjustedPia < spouses[spouse].adjustedPia) {
          profitableSpouse = spouses[spouse];
        }
      }
    }

    return [profitableSpouse];
  } */

  public static parseDateTime(time24) {
    var date = new Date(time24.toString());
    var options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    var timeString = date.toLocaleString('en-US', options);
    if (timeString == '12:00 AM')
      timeString = '';
    return timeString;
  }

  public static calculateMarriageAge(client, spouse) {
    var clientDob = new Date(client.DOB);
    var anniversary = new Date(spouse.anniversary);
    // console.log('asd', clientDob, anniversary);
    return this.calculateAge(clientDob, anniversary);
  }

  public static calculateAge(clientDob, anniversary) {
    var ageDifMs = anniversary - clientDob.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  public static months: any = [
    {
      "name": "January",
      "val": 1,
    },
    {
      "name": "February",
      "val": 2,
    },
    {
      "name": "March",
      "val": 3,
    },
    {
      "name": "April",
      "val": 4,
    },
    {
      "name": "May",
      "val": 5,
    },
    {
      "name": "June",
      "val": 6,
    },
    {
      "name": "July",
      "val": 7,
    },
    {
      "name": "August",
      "val": 8,
    },
    {
      "name": "September",
      "val": 9,
    },
    {
      "name": "October",
      "val": 10,
    },
    {
      "name": "November",
      "val": 11,
    },
    {
      "name": "December",
      "val": 12,
    },
  ]

  public static allStates = [
    // {
    //     "name": "National Average",
    //     "abbreviation": "NA"
    // },
    {
      "name": "Alabama",
      "abbreviation": "AL"
    },
    {
      "name": "Alaska",
      "abbreviation": "AK"
    },
    {
      "name": "Arizona",
      "abbreviation": "AZ"
    },
    {
      "name": "Arkansas",
      "abbreviation": "AR"
    },
    {
      "name": "California",
      "abbreviation": "CA"
    },
    {
      "name": "Colorado",
      "abbreviation": "CO"
    },
    {
      "name": "Connecticut",
      "abbreviation": "CT"
    },
    {
      "name": "Delaware",
      "abbreviation": "DE"
    },
    {
      "name": "District Of Columbia",
      "abbreviation": "DC"
    },
    {
      "name": "Florida",
      "abbreviation": "FL"
    },
    {
      "name": "Georgia",
      "abbreviation": "GA"
    },
    {
      "name": "Hawaii",
      "abbreviation": "HI"
    },
    {
      "name": "Idaho",
      "abbreviation": "ID"
    },
    {
      "name": "Illinois",
      "abbreviation": "IL"
    },
    {
      "name": "Indiana",
      "abbreviation": "IN"
    },
    {
      "name": "Iowa",
      "abbreviation": "IA"
    },
    {
      "name": "Kansas",
      "abbreviation": "KS"
    },
    {
      "name": "Kentucky",
      "abbreviation": "KY"
    },
    {
      "name": "Louisiana",
      "abbreviation": "LA"
    },
    {
      "name": "Maine",
      "abbreviation": "ME"
    },
    {
      "name": "Maryland",
      "abbreviation": "MD"
    },
    {
      "name": "Massachusetts",
      "abbreviation": "MA"
    },
    {
      "name": "Michigan",
      "abbreviation": "MI"
    },
    {
      "name": "Minnesota",
      "abbreviation": "MN"
    },
    {
      "name": "Mississippi",
      "abbreviation": "MS"
    },
    {
      "name": "Missouri",
      "abbreviation": "MO"
    },
    {
      "name": "Montana",
      "abbreviation": "MT"
    },
    {
      "name": "Nebraska",
      "abbreviation": "NE"
    },
    {
      "name": "Nevada",
      "abbreviation": "NV"
    },
    {
      "name": "New Hampshire",
      "abbreviation": "NH"
    },
    {
      "name": "New Jersey",
      "abbreviation": "NJ"
    },
    {
      "name": "New Mexico",
      "abbreviation": "NM"
    },
    {
      "name": "New York",
      "abbreviation": "NY"
    },
    {
      "name": "North Carolina",
      "abbreviation": "NC"
    },
    {
      "name": "North Dakota",
      "abbreviation": "ND"
    },
    {
      "name": "Ohio",
      "abbreviation": "OH"
    },
    {
      "name": "Oklahoma",
      "abbreviation": "OK"
    },
    {
      "name": "Oregon",
      "abbreviation": "OR"
    },
    {
      "name": "Pennsylvania",
      "abbreviation": "PA"
    },
    {
      "name": "Rhode Island",
      "abbreviation": "RI"
    },
    {
      "name": "South Carolina",
      "abbreviation": "SC"
    },
    {
      "name": "South Dakota",
      "abbreviation": "SD"
    },
    {
      "name": "Tennessee",
      "abbreviation": "TN"
    },
    {
      "name": "Texas",
      "abbreviation": "TX"
    },
    {
      "name": "Utah",
      "abbreviation": "UT"
    },
    {
      "name": "Vermont",
      "abbreviation": "VT"
    },
    {
      "name": "Virginia",
      "abbreviation": "VA"
    },
    {
      "name": "Washington",
      "abbreviation": "WA"
    },
    {
      "name": "West Virginia",
      "abbreviation": "WV"
    },
    {
      "name": "Wisconsin",
      "abbreviation": "WI"
    },
    {
      "name": "Wyoming",
      "abbreviation": "WY"
    }
  ]

  public static convertMarketingMaterialOrInfoCenterToNewFormat(obj) {
    let result = [];
    let document = {};

    for (let key in obj) {
      if (obj[key].length) {
        for (let item in obj[key]) {
          if (obj[key][item]) {
            document = obj[key][item];
            document['Category'] = key.toString();
            result.push(document);
          }
        }
      } else {
        document = {
          Category: key.toString(),
        };
        result.push(document);
      }
    }

    return result;
  }

  public static convertMarketingMaterialOrInfoCenterToOldFormat(arr) {
    let result = {}

    arr.forEach((cat, i) => {
      result[cat.category] = [];
      arr[i].items.forEach((doc, j) => {
        if (doc)
          result[cat.category].push(doc);
      });
    });

    return result;
  }

  public static formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  public static removeCurrencyFormatting(s) {
    return Number(s.replace('$', '').replace(',', ''));
  }

  public static formatReportTypeID(ReportTypeID: number, isRiskTolerance: boolean = false) {
    let report = "";

    switch (ReportTypeID) {
      case 1:
        report = 'Social Security'
        break;
      case 2:
        report = 'Medicare Means Testing'
        break;
      case 3:
        report = 'Healthcare';
        break;
      case 4:
        report = 'Longterm Care'
        break;
      case 5:
        report = 'Healthcare Risk Tolerance';
        break;
      case 6:
        report = 'Social Security Risk Tolerance';
        break;
      case 7:
        report = 'Longterm Care Risk Tolerance';
        break;
      default:
        break;
    }

    return report;
  }

  public static calculateRateAssumptionYears(clientAge, clientLifeExpectancy) {
    const step = Math.floor(Math.max(0, Number(clientLifeExpectancy) - Number(clientAge)) / 3);
    console.log(step, clientAge, clientLifeExpectancy);
    return { p1EndAge: Number(clientAge) + step, p2EndAge: Number(clientAge) + (step * 2) };
  }
}
